import React, { Component } from "react";
import styles from "./HighlightBanner.module.scss";
import PlusMinus from "../plus-minus";
import { Element, scroller } from "react-scroll";
import Img from "gatsby-image";

function createMarkup(value) {
	return {
		__html: value
	};
}

class HighlightBanner extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false
		};
	}

	handleToggle = () => {
		if (this.state.open) {
			scroller.scrollTo(this.props.title, {
				duration: 500,
				delay: 0,
				smooth: true,
				offset: -150 // Scrolls to element + 50 pixels down the page
			});
		}

		this.setState({ open: !this.state.open });
	};

	render() {
		const { props } = this;
		return (
			<div
				className={styles.highlight_banner + " " + props.className}
				style={props.style}
			>
				<div className={"container "}>
					<Element
						name={props.title}
						className="element mb-3 mb-lg-0"
					>
						<div
							className={
								"row " +
								(props.contentAlign ||
									"justify-content-md-center")
							}
						>
							<div
								className={
									styles.highlight_image +
									" " +
									(props.contentAlign === "start"
										? styles.order_2
										: styles.order_1)
								}
							>
								<Img
									title={props.image.title}
									alt={props.image.title}
									sizes={props.image.sizes}
								/>
							</div>
							<div
								className={
									styles.highlight_text +
									" " +
									(props.contentAlign === "start"
										? styles.order_1
										: styles.order_2)
								}
								style={{
									...props.style
								}}
							>
								<div>
									<h3 className={styles.h3}>{props.title}</h3>
									<hr className={styles.hr} />
									<div
										dangerouslySetInnerHTML={createMarkup(
											props.description.content.html
										)}
									/>
								</div>
							</div>
						</div>
					</Element>
					{/* MORE */}
					<div
						className={
							"row " +
							(props.contentAlign === "start"
								? "justify-content-start "
								: "justify-content-lg-end ") +
							(this.state.open
								? styles.more_wrapper_open
								: styles.more_wrapper_closed)
						}
					>
						<div
							className={
								styles.images +
								" " +
								(this.state.open
									? styles.more_open
									: styles.more_closed)
							}
							style={{
								order:
									props.contentAlign === "start" ? "2" : "1"
							}}
						>
							{props.gallery &&
								props.gallery.length > 0 &&
								props.gallery.map((item, i) => {
									return (
										<Img
											key={"image-" + i}
											title={item.title}
											alt={item.title}
											sizes={item.sizes}
										/>
									);
								})}
						</div>
						<div
							className={
								"col-lg-6 " +
								styles.section +
								" " +
								(this.state.open
									? styles.more_open
									: styles.more_closed)
							}
							style={{
								order:
									props.contentAlign === "start" ? "1" : "2"
							}}
						>
							{props.details &&
								props.details.length > 0 &&
								props.details.map((item, i) => {
									return (
										<div key={"detail-" + i}>
											<h4 className={styles.h4}>
												{item.title}
											</h4>
											<div
												dangerouslySetInnerHTML={createMarkup(
													item.content.content.html
												)}
											/>
										</div>
									);
								})}
						</div>
						<div
							className={
								"col-12 d-flex " +
								(props.contentAlign === "start"
									? "justify-content-end justify-content-lg-start"
									: "justify-content-end")
							}
							style={{ padding: "0 5%", order: "3" }}
						>
							<PlusMinus
								contentAlign={props.contentAlign}
								state={this.state.open}
								toggle={this.handleToggle}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default HighlightBanner;



// WEBPACK FOOTER //
// ./src/components/HighlightBanner/index.js